import React from "react";

/*
Expected Content:
-----------------
static childContextTypes = {
  register: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
  validateState: PropTypes.func.isRequired,
  components: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.instanceOf(Button),
    PropTypes.instanceOf(Input),
    PropTypes.instanceOf(Select),
    PropTypes.instanceOf(Textarea)
  ])),
  errors: PropTypes.objectOf(PropTypes.array)
};
*/

const ValidationContext = React.createContext({});

export default ValidationContext;
export const ValidationContextProvider = ValidationContext.Provider;
export const ValidationContextConsumer = ValidationContext.Consumer;